(ns teamoesterreich.admin-mode.data.event
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn serialize-path [in]
  (json/serialize in))


(defn get-event-list-elements [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event?comfort=1&category=EINSATZ")
                  (fn [r-list status]
                    ;(log/debug "event-list-elements done" r-list status)
                    (when (= status 200)
                      (done-fn (into {} (map (fn [e] [(get e "crowdtaskerEvent-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                               )))))

(defn get-online-event-list-elements [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event?comfort=1&category=ONLINE")
                  (fn [r-list status]
                    ;(log/debug "event-list-elements done" r-list status)
                    (when (= status 200)
                      (done-fn (into {} (map (fn [e] [(get e "crowdtaskerEvent-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                               )))))

(defn get-canYou-event-list-elements [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event?comfort=1&category=CAN_YOU")
                  (fn [r-list status]
                    ;(log/debug "event-list-elements done" r-list status)
                    (when (= status 200)
                      (done-fn (into {} (map (fn [e] [(get e "crowdtaskerEvent-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                               )))))





(defn <event-load [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/details")
                  (fn [r-list status]
                    ;(log/debug "event-list-get-event-details done" r-list status)
                    (when (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))))))


(defn >new-classic-event [name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event")
                   (ajax/serialize {:crowdtaskerEvent-active    true
                                    :crowdtaskerEvent-published false
                                    :crowdtaskerEvent-category  "EINSATZ"
                                    :crowdtaskerEvent-orgId     (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))
                                    :crowdtaskerEvent-status    "created"
                                    :crowdtaskerEvent-name      name})
                   (fn [r-list status]
                     ;(log/debug "event-list-get-event-details done" r-list status)
                     (if (= status 200)
                       (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                       (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                )))))

(defn >new-online-event [name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event")
                   (ajax/serialize {:crowdtaskerEvent-active    true
                                    :crowdtaskerEvent-published false
                                    :crowdtaskerEvent-category  "ONLINE"
                                    :crowdtaskerEvent-orgId     (first (d-rights/get-rights-orgId-filter d-rights/CROWDTASKER))
                                    :crowdtaskerEvent-status    "created"
                                    :crowdtaskerEvent-name      name})
                   (fn [r-list status]
                     ;(log/debug "event-list-get-event-details done" r-list status)
                     (if (= status 200)
                       (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                       (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                )))))

(defn >new-canYou-event [name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event")
                   (ajax/serialize {:crowdtaskerEvent-active    true
                                    :crowdtaskerEvent-published false
                                    :crowdtaskerEvent-category  "CAN_YOU"
                                    :crowdtaskerEvent-orgId     (first (d-rights/get-rights-orgId-filter d-rights/CANYOU))
                                    :crowdtaskerEvent-status    "created"
                                    :crowdtaskerEvent-name      name})
                   (fn [r-list status]
                     ;(log/debug "event-list-get-event-details done" r-list status)
                     (if (= status 200)
                       (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                       (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                                )))))



(defn >event-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">event-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                      (done-fn {:error (str "Fehler: Datensatz konnte nicht angelegt werden! " status)}
                               )))))

(defn >event-send-alarm [uuid]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/send-alarm")
                  (fn [r-list status]
                    (log/debug ">event-send-alarm done" r-list status))))

(defn >event-send-test-push [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/send-test-push?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">event-send-test-alarm done" r-list status))))
(defn >event-send-test-alarm [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/send-test-alarm?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">event-send-test-alarm done" r-list status))))

(defn >event-send-test-briefing [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/send-test-briefing?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">event-send-test-alarm done" r-list status))))


(defn >event-send-test-description [uuid tomId]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/send-test-description?tomId=" tomId)
                  (fn [r-list status]
                    (log/debug ">event-send-test-alarm done" r-list status))))




(defn event-list-update [& [on-finished]]
  (let [uuid (get-in @v-state/app-state [:selected-event :crowdtaskerEvent-uuid])]
    (<event-load uuid (fn [response]
                        (swap! v-state/app-state assoc :selected-event response)
                        (when on-finished (on-finished))
                        ))))

(defn event-update [& [on-finished]]
  (let [uuid (get-in @v-state/app-state [:selected-event :crowdtaskerEvent-uuid])]
    (<event-load uuid (fn [response]
                        (swap! v-state/app-state assoc :selected-event response)
                        (when on-finished (on-finished))
                        ))))




(defn >event-save-polygon [uuid path]
  (log/out "save new polygon: " (ajax/serialize {:crowdtaskerEvent-uuid                      (str uuid)
                                                 :crowdtaskerEvent-locationPolygonJsonString (serialize-path path)
                                                 }))
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid)
                  (ajax/serialize {:crowdtaskerEvent-uuid                      (str uuid)
                                   :crowdtaskerEvent-locationPolygonJsonString (serialize-path path)
                                   :crowdtaskerEvent-locationState             ""
                                   :crowdtaskerEvent-locationDistrict          ""
                                   })))


(defn >event-save-county-state [uuid state district]
  (let [body (ajax/serialize {:crowdtaskerEvent-uuid                      (str uuid)
                              :crowdtaskerEvent-locationState             (str state)
                              :crowdtaskerEvent-locationDistrict          (str district)
                              :crowdtaskerEvent-locationPolygonJsonString (str "")
                              })]
    (log/out "save new path: " body)
    (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid) body)
    ))





(defn >new-event-slot [uuid name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/add-slot")
                   (ajax/serialize {:eventSlot-name name})
                   (fn [r-list status]
                     (log/debug ">add-slot done" r-list status)
                     (done-fn)
                     )))

(defn >event-slot-save [uuid data done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/slot/" uuid)
                  (ajax/serialize data)
                  (fn [r-list status]
                    (log/debug ">event-slot-save done" r-list status)
                    (if (= status 200)
                      (done-fn (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))))))


(defn >event-save-event-conditions [uuid memberFilter memberSoftFilter & [done-fn]]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid)
                  (ajax/serialize {:crowdtaskerEvent-uuid             (str uuid)
                                   :crowdtaskerEvent-memberFilter     (ajax/serialize memberFilter)
                                   :crowdtaskerEvent-memberSoftFilter (ajax/serialize memberSoftFilter)
                                   })
                  (fn [r-list status]
                    (when done-fn (done-fn))
                    )))



(defn >event-add-admin [uuid tomId done-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/admin/" tomId)
                  (ajax/serialize {})
                  (fn [r status]
                    (when done-fn (done-fn))
                    )))

(defn >event-remove-admin [uuid tomId done-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/admin/" tomId)
                     (ajax/serialize {})
                     (fn [r status]
                       (when done-fn (done-fn))
                       )))

(defn >event-copy [uuid new-name done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/crowdtasker-event/" uuid "/copy")
                     (ajax/serialize {:crowdtaskerEvent-name (str new-name)})
                     (fn [r status]
                       (when done-fn (done-fn))
                       )))









